// // src/plugins/images.ts
// import { App } from 'vue'
const RAW_BASE = process?.env?.VUE_APP_API_URL_IMG || '';
// VUE_APP_API_URL_IMG=http://localhost/api_conoce_bolivia/public
console.log("=========", RAW_BASE);
const API_IMG_BASE = String(RAW_BASE).replace(/\/$/, '');
function buildImg(url) {
    if (!url)
        return '';
    if (/^https?:\/\//i.test(url))
        return url;
    const path = String(url).replace(/^\//, '');
    return API_IMG_BASE ? `${API_IMG_BASE}/${path}` : `/${path}`;
}
export default {
    install(app) {
        app.config.globalProperties.$apiImgBase = API_IMG_BASE;
        app.config.globalProperties.$buildImg = buildImg;
    }
};
